import React from "react";

const LogoutIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
    >
      <g id="file_download">
        <path
          id="Vector"
          d="M11.25 4.5H13.5V13.5H11.25V15H13.5C14.325 15 15 14.325 15 13.5V4.5C15 3.675 14.325 3 13.5 3H11.25V4.5ZM8.25 5.25L7.1925 6.3075L9.1275 8.25H3V9.75H9.1275L7.1925 11.6925L8.25 12.75L12 9L8.25 5.25Z"
          fill={props.themeName != "light"?"#DADADA":"#333333"}
        />
      </g>
    </svg>
  );
};

export default LogoutIcon;
